<template>
  <Layout>
    <b-overlay :show="isLoading" rounded="sm">

    <div class="card">
      <div class="card-body">
        <PageHeader :title="title" :items="items" />

         <div class="form-row">
           <div class="form-group col-md-12">
             <label>Expediente</label>
             <v-select
                 :options="expedientes"
                 label="obra_expediente"
                 :reduce="desc=>desc.expediente_id"
                 v-model="expediente_id"
             />
           </div>
           </div>
        <div class="form-row">
           <div class="form-group col-md-4">
             <label>Fecha</label>
             <VueCtkDateTimePicker
                     v-model="fecha"
                     :locale="'es'"
                     :input-size="'sm'"
                     :format="'YYYY-MM-DD'"
                     :formatted="'YYYY-MM-DD'"
                     :range="true"

                     :only-date="true"
                     :no-header="true"
                     :custom-shortcuts="custom"
             />
           </div>
          <div class="form-group col-md-4">
            <label>Tipo </label>
            <select class="form-control" v-model="agrupado" >
              <option value="0">Reporte por fecha</option>
              <option value="1">Reporte acumuluado</option>
              <option value="2">Reporte agrupado por especialidad</option>

            </select>
          </div>
           <div class="form-group col-md-2">
             <button class="btn btn-primary mt-4" v-on:click="loadItems">Ver</button>
             <button type="button" v-show="$can('avance-ver')"
                     class="btn btn-primary mt-4 ml-2" v-on:click="descargarExcel">
               <i class="fa fa-file-excel"></i> Exportar
             </button>
             <button type="button" v-show="$can('avance-ver')"
                     class="btn btn-primary mt-4 ml-2" v-on:click="hojaMetradoDiario">
               <i class="fa fa-file-pdf"></i> Hoja Metrado
             </button>
             <!--<button class="btn btn-primary mt-4 ml-1" v-on:click="onBtnExport">Descargar CSV</button>-->
           </div>
         </div>
        <!--<div class="row">
          <div class="col-md-12">
            <month-picker-input  :no-default="true" style="z-index:1"></month-picker-input>
          </div>

        </div>-->
         <div class="row">
           <ag-grid-vue
                   style="width: 100%; height: 400px"
                   class="ag-theme-balham"
                   :columnDefs="columnDefs"
                   :rowData="rowData"
                   :gridOptions="gridOptions"
                   @grid-ready="onGridReady"
           >
           </ag-grid-vue>
         </div>
         <div class="row">
           <div class="col-md-12 text-right mt-4">
             <h4>Total:S/ {{total}}</h4>
           </div>
         </div>

        </div>
        <div class="row">
          <div class="col-md-12">
            <p>(*) El costo unitario en el reporte por fecha es el costo unitario registrado al momento registrar el avance, el costo unitario en el reporte agrupado es el costo unitario registrado en el presupuesto.</p>
          </div>

        </div>
      </div>
    </b-overlay>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Reportes",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Reportes de avance",
      items: [
        {
          text: "Avance",
        }
      ],
      isLoading: false,
      server: process.env.VUE_APP_BACKEND,
      lista:[],
      fecha:null,
      fecha_mostrar:null,
      expediente_id:null,
      gridApi: null,
      columnApi: null,
      columnDefs:[],
      rowData:[],
      gridOptions: {
        //floatingFiltersHeight:50,
        defaultColDef: {
          sortable: true,resizable: true
        },
      },
      agrupado:"1",
      total:0,
      expedientes:[],
      custom:[
        { key: 'thisWeek', label: 'Esta semana', value: 'isoWeek' },
        { key: 'lastWeek', label: 'Ultima semana', value: '-isoWeek' },
        { key: 'last7Days', label: 'Ultimos 7 dias', value: 7 },
        { key: 'last30Days', label: 'Ultimos 30 dias', value: 30 },
        { key: 'thisMonth', label: 'Este mes', value: 'month' },
        { key: 'lastMonth', label: 'Ultimo mes', value: '-month' },
        { key: 'thisYear', label: 'Este año', value: 'year' },
        { key: 'lastYear', label: 'Ultimo año', value: '-year' }
      ]
    };
  },
  beforeMount() {
/*     'a.id',
                    'a.partida_id',
                    'a.fecha',
                    'ep.codigo_partida',
                    'ep.expediente_id',
                    'ep.partida',
                    'ep.unidad_medida',
                    'a.cantidad',
                    'a.estado',
                    'a.costo_unitario',
                    'a.subtotal',*/
      this.columnDefs= [
        { headerName: "ID", field: "id", width:"80px",hide:"true"},
        { headerName: "Fecha", field: "fecha", resizable: true ,width:"90px",filter: 'agTextColumnFilter'},
        { headerName: "Codigo", field: "codigo_partida", resizable: true,width:"130px",filter: 'agTextColumnFilter',floatingFilter: true},
        { headerName: "Partida", field: "partida", resizable: true,width:"250px",filter: 'agTextColumnFilter',floatingFilter: true},
        { headerName: "UM", field: "unidad_medida", width:"100px"},
        { headerName: "Cantidad", field: "cantidad", resizable: true ,width:"120px",filter: 'agTextColumnFilter',floatingFilter: true, cellStyle: {textAlign: "right"}},
        { headerName: "CU Actual", field: "costo_unitario",width:"100px", cellStyle: {textAlign: "right"}},
        { headerName: "Subtotal", field: "subtotal",width:"100px" , cellStyle: {textAlign: "right"}},
      ];
      this.rowData= [

      ];

  },
  methods: {
    hojaMetradoDiario(){
      /*let routeData = this.$router.resolve({
        path: '/about',
        query: {
          city : 'test',
          departureFlightDate : 'test',
          arrivalFlightDate : 'test',
          idParkingService : 'test',
          price : 'test'
        }
      });*/
      var fec=JSON.stringify(this.fecha)
      window.open(process.env.VUE_APP_BACKEND + "/avance-pdf?expediente_id="+this.expediente_id+
          "&fecha="+fec
          , '_blank');
      /*this.isLoading=true;

      this.axios.get(process.env.VUE_APP_BACKEND + "/api/avance/reportes-rango-excel",
          {
            responseType: 'arraybuffer',
            'params':{
              'expediente_id':this.expediente_id,
              'fecha':this.fecha,
              //'agrupado':this.agrupado
            }
          })
          .then(response => {
            this.$downloadFile(response, 'hoja_metrado.pdf','application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
          }, response => {
            console.warn('error from download_contract');
            console.log(response);
            this.$swal("error","Error generando el reporte",'error')
            // Manage errors
          })
          .finally(()=>{
            this.isLoading=false;
          });*/
    },
    descargarExcel(){
      this.isLoading=true;
      this.axios.get(process.env.VUE_APP_BACKEND + "/api/avance/reportes-rango-excel",
          {
            responseType: 'arraybuffer',
            'params':{
              'expediente_id':this.expediente_id,
              'fecha':this.fecha,
              'agrupado':this.agrupado
            }
          })
          .then(response => {
            this.$downloadFile(response, 'avance_rango.xlsx','application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
          }, response => {
            console.warn('error from download_contract');
            console.log(response);
            this.$swal("error","Error generando el reporte",'error')
            // Manage errors
          })
          .finally(()=>{
            this.isLoading=false;
          });
    },
    onBtnExport() {
      this.gridApi.exportDataAsCsv();
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;

    },
    loadItems()
    {
      this.isLoading = true;
      this.axios.get(
      process.env.VUE_APP_BACKEND + "/api/avance/reportes-rango",
          {
            params:
                    {
                      fecha:this.fecha,
                      expediente_id:this.expediente_id,
                      agrupado:this.agrupado
                    }
          }
      )
      .then((response)=> {
        //this.fecha_mostrar=this.fecha;
        //this.lista=response.data;
        this.rowData=response.data.partidas;
        this.total=response.data.total;
        //this.gridOptions.api.sizeColumnsToFit();

      })
      .catch(() => {
        this.$swal("error", "Error", "error");
      })
      .finally(() => {
        this.isLoading = false;
      });
    },

    cargarExpedientes(){
      this.isLoading=true;
      this.axios.get(process.env.VUE_APP_BACKEND + "/api/expedientes")
          .then((response)=>{
            this.expedientes=response.data;
            if(this.expedientes.length>0){
              this.expediente_id=this.expedientes[0].expediente_id;
            }
          })
          .catch(()=>{
            this.$swal('Cuidado',"Error cargando los expedientes",'warning');
          })
          .finally(()=>this.isLoading=false)
    },
  },
  mounted() {
    this.cargarExpedientes();
    //var date= new Date();
    //this.fecha=new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString().substring(0, 10)
  }
}
</script>

<style>
.fixtable {
  color: #000000 !important;
}
</style>
